/**
 * Distance offset (in pixels) to apply to SUI popups that should sit
 * clear of their trigger — i.e. lift the popup ~0.5rem away so the
 * arrow doesn't visually clip the trigger's border. Useful when the
 * trigger sits inside a bordered container like an InfoChip, but also
 * a sensible default for popups in general.
 *
 * Pass to `<Popup offset={LIFTED_POPUP_OFFSET} />`.
 *
 * The shape is `[skidding, distance]` per `@popperjs/core`'s offset
 * modifier.
 */
export const LIFTED_POPUP_OFFSET = [0, 8] as [number, number];

/**
 * Popper modifiers that let a popup flip through all horizontal/vertical
 * variants (top-start/top-end/bottom/bottom-start/bottom-end) so triggers
 * near a window edge re-anchor instead of overflowing. SUI restyles the
 * arrow per placement.
 *
 * Pass to `<Popup popperModifiers={EDGE_AWARE_POPPER_MODIFIERS} />`.
 */
export const EDGE_AWARE_POPPER_MODIFIERS = [
  {
    name: 'flip',
    options: {
      fallbackPlacements: [
        'top-start',
        'top-end',
        'bottom',
        'bottom-start',
        'bottom-end',
      ],
      rootBoundary: 'viewport',
    },
  },
];
